// window.cateData.isShowLoading = true; //页面需要loading加载数据
var campaignPagee2026springModule = {

    initVue: function () {
        // 自定义点击空白区域指令
        var clickoutside = {
            bind: function (el, binding, vnode) {
                function documentHandler(e) {
                    // 这里判断点击的元素是否是本身，是本身，则返回
                    if (el.contains(e.target)) {
                        return false;
                    }
                    // 判断指令中是否绑定了函数
                    if (binding.expression) {
                        // 如果绑定了函数 则调用那个函数，此处binding.value就是handleClose方法
                        binding.value(e);
                    }
                }

                // 给当前元素绑定个私有变量，方便在unbind中可以解除事件监听
                el.__vueClickOutside__ = documentHandler;
                document.addEventListener('click', documentHandler);
            },
            update: function () {
            },
            unbind: function (el, binding) {
                document.removeEventListener('click', el.__vueClickOutside__);
                delete el.__vueClickOutside__;
            }
        }

        // utm字段
        var utmObj = {};
        // 获取utm字段，任意一个字段有值，把所有的值都替换，都无值的时候，取现有cookie
        var utm_source = common.getUrlPara('utm_source') || '';
        var utm_medium = common.getUrlPara('utm_medium') || '';
        var utm_campaign = common.getUrlPara('utm_campaign') || '';
        var utm_content = common.getUrlPara('utm_content') || '';
        var utm_term = common.getUrlPara('utm_term') || '';
        if (utm_source || utm_medium || utm_campaign || utm_content || utm_term) {
            utmObj = {
                utm_source: utm_source,
                utm_medium: utm_medium,
                utm_campaign: utm_campaign,
                utm_content: utm_content,
                utm_term: utm_term
            };
            common.setCookie('utmObj', JSON.stringify(utmObj));
        } else {
            if (getCookie('utmObj')) {
                utmObj = JSON.parse(getCookie('utmObj'));
            }
        }

        this.viewModel = new Vue({
            el: '.page-module-2026spring',
            directives: {
                clickoutside: clickoutside
            },
            data: {
                backUrl: getUrlPara('backUrl'),
                downTime: 60,
                timer: null,
                input: {
                    code: {
                        value: '',
                        error: '',
                    }
                },
                // 唯一字段是否重复
                uniqueExist: {
                    mobile: false,
                    email: false
                },
                formData: [], // 字段数据
                mobileObject: null, // 手机字段对象
                formAction: '', //
                submitFormData: {
                    formId: '', // 注册表单id
                    url: window.location.href,
                    browseInfo: client.browseInfo,
                    globalUserId: ""
                },
                isSendSmsing: false, // 是否正在发送验证码
                isSubmiting: false, // 是否正在提交
                isFangyuan: window.location.href.indexOf('v=v') > -1, //是否是访员注册
                isRegisterShow: false,
                input2: {
                    unique: {
                        value: '',
                        error: ''
                    },
                    smsCode: {
                        value: '',
                        error: ''
                    }
                },
                logining: false,
                smsCodeSended: false, // 是否发送过验证码
                isSignUp: false,
                isShowPrivacyDialog: false, // 协议同意弹窗
                pendingSendSmsType: '', // 待发送的验证码类型：'register' 或 'login'
                formUserInfo: '', //用户信息
                zeroFormStatus: 0, // 0元团队表单提交状态 0:未提交/未登录 1:已提交
                timeLineStep: 1, // 时间进度0，1，2，3

                // 积分兑换功能
                point: 100, // 积分
                coupons: [], // 可兑换的优惠券
                couponSwiper: null, // 优惠券 swiper
                getPointModalType: '登录', // 是登录获取还是注册获取
                isShowExchangeModal: false,
                isShowRedBackModal: false,
                isShowMiaoshaTip: false,
                isShowFanchangModal:false, //返场豪礼弹窗
                redbackQrcode: '',
                exchaneModalData: {
                    type: '',
                    id: 0,
                    point: 200,
                    couponName: '200元京东卡'
                }, // 兑换弹窗的数据

                // 抽奖模块
                isDrawing: false,
                isShowAddressModal: false,
                addressField: {
                    name: {
                        placeholder: '请输入您的真实姓名，快递需本人签收',
                        error: false,
                        errorText: '请输入姓名',
                        require: 1,
                        label: 'name',
                        labelText: '姓名',
                        value: '',
                    },
                    mobile: {
                        placeholder: '请输入手机号',
                        error: false,
                        errorText: '请输入手机号',
                        require: 1,
                        label: 'mobile',
                        labelText: '手机号',
                        value: '',
                    },
                    address: {
                        placeholder: '请输入完整收货地址',
                        error: false,
                        errorText: '请输入收货地址',
                        require: 1,
                        label: 'address',
                        labelText: '收货地址',
                        value: '',
                    },
                    company: {
                        placeholder: '请输入完整公司名称',
                        error: false,
                        errorText: '请输入公司名称',
                        require: 1,
                        label: 'company',
                        labelText: '公司名称',
                        value: '',
                    },
                },
                redbackQrcode: '',
                exchaneModalData: {
                    type: '',
                    id: 0,
                    point: 200,
                    couponName: '200元京东卡'
                }, // 兑换弹窗的数据
                count: 0,
                verifiedEmail: false, //是否填写过企业邮箱

                // 套装视频-手机端
                kitsVideo: [
                    // 移动套装
                    {
                        "id": 2601283182485926,
                        "list": [
                            {
                                "title": "Dell Pro 13 Plus 笔记本",
                                "top": 80,
                                "left": 320,
                                "w": 220,
                                "h": 140,
                                "url": "https://dellvideo.smarket.net.cn/000b7f882c9271f0997a5017e1e90102/d8126951b5b847a387eb6717e7d6d7ec-f06043152a8cdeb76d4136b4542ff806-ld.mp4"
                            },
                        ]
                    },
                    // 超强
                    {
                        "id": 2601281830329261,
                        "list": [
                            {
                                "title": "Dell Pro 微小型机",
                                "top": 80,
                                "left": 100,
                                "w": 100,
                                "h": 210,
                                "url": "https://dellvideo.smarket.net.cn/40a4e8711b5471f08d8e4531948c0102/18f4fcdbe8134d2e82a71b2f569f2b18-547355cdf401fa4c1f31b563dfd57106-ld.mp4"
                            },
                        ]
                    },
                    // 极速套装
                    {
                        "id": 2601283934006937,
                        "list": []
                    },
                    // 商务套装
                    {
                        "id": 2601282087676207,
                        "list": [
                            {
                                "title": "Dell Pro 14 Premium 笔记本",
                                "top": 65,
                                "left": 280,
                                "w": 190,
                                "h": 140,
                                "url": "https://dellvideo.smarket.net.cn/f042c73ed4b571efbfd26632b68f0102/3fcb7902e7944c1f864765f7bedb1601-0be4305d32a3f02d2f952a57545c51d9-ld.mp4"
                            },
                        ]
                    },
                    // 高效套装
                    {
                        "id": 2601281510568141,
                        "list": []
                    }
                ],
                showOverTip: false,
                showPrizePop: false,
                winPrize: {
                    id:0,
                    prizeType: 0,
                    prizeName: '',
                    prizeImg: '',
                },
                isShowEmailDialog: false,
                emailInput: {
                    unique: {
                        value: '',
                        error: ''
                    },
                    smsCode: {
                        value: '',
                        error: ''
                    },
                    downTime: 60,
                    timer: null,
                    isSendSmsing: false, // 是否正在发送验证码
                },
                eventId: 94,
                prizes: [],
                prizesList: [],
                auth: -1,
                drawNumber: 0, //抽奖人数
                // 获奖信息
                winningInfor: {
                    time: null,
                    animate: false,
                    list:  [
                        "185****6617 成功抽中 微信红包",
                        "136****5981 成功抽中 笔记本立减券",
                        "138****1458 成功抽中 马年限定保温杯",
                        "138****8103 成功抽中 蓝牙鼠标",
                        "185****1128 成功抽中 Opti T5090 台式机",
                        "132****3920 成功抽中 台式机T8 迷你机",
                        "186****2111 成功抽中 微信红包",
                        "138****0391 成功抽中 笔记本立减券",
                        "157****2310 成功抽中 马年限定保温杯",
                        "159****9424 成功抽中 蓝牙鼠标",
                        "177****2342 成功抽中 Opti T5090 台式机",
                        "133****5937 成功抽中 台式机T8 迷你机",
                        "156****2739 成功抽中 微信红包",
                        "147****3560 成功抽中 笔记本立减券",
                        "185****9463 成功抽中 马年限定保温杯",
                        "176****0232 成功抽中 蓝牙鼠标",
                        "184****2431 成功抽中 Opti T5090 台式机",
                        "155****6873 成功抽中 台式机T8 迷你机",
                        "158****2463 成功抽中 微信红包",
                        "134****3509 成功抽中 笔记本立减券",
                        "135****3092 成功抽中 马年限定保温杯",
                        "133****3936 成功抽中 蓝牙鼠标",
                    ]
                },
                winningInforDialog: false,
                //我的奖品弹窗
                isShowMyPrize:false,
                myPrizeList:[],
                //红包领取弹窗
                isShowMyPrizeHongbao: false,
                hongbaoTitle: '微信红包',
                hongbaoSub: '扫描公众号二维码，<br>或关注【戴尔企采网】公众号<br>查看微信红包了解更多活动',
                hongbaoQrImg: '',

                //新品推荐
                newId: 2601282924218702,
                newProductList: [],
                newProductListYuan: [],
                newProductTabList2: [],
                newProductTabList: [
                    {
                        id: 1,
                        name: '爆款特惠',
                        isParent: true,
                        isActived: true,
                        list: [
                            {
                                name: "显示器",
                                isActived: true,
                            },
                            {
                                name: "商用笔记本",
                                isActived: false,
                            },
                            {
                                name: "商用台式机",
                                isActived: false,
                            },
                            {
                                name: "专业工作站",
                                isActived: false,
                            },
                            {
                                name: "服务器",
                                isActived: false,
                            },
                        ]
                    },
                    {
                        id: 2,
                        name: '热门岗位',
                        isParent: true,
                        isActived: false,
                        list: [
                            {
                                name: "工程师/开发",
                                isActived: false,
                            },
                            {
                                name: "设计师/媒体",
                                isActived: false,
                            },
                            {
                                name: "运营/市场/销售",
                                isActived: false,
                            },
                            {
                                name: "财务/行政/客服",
                                isActived: false,
                            },
                            {
                                name: "企业高管",
                                isActived: false,
                            },
                        ]
                    },
                    {
                        id: 3,
                        name: '应用场景',
                        isParent: true,
                        isActived: false,
                        list: [
                            {
                                name: "开发测试",
                                isActived: false,
                            },
                            {
                                name: "渲染设计",
                                isActived: false,
                            },
                            {
                                name: "移动办公",
                                isActived: false,
                            },
                            {
                                name: "日常办公",
                                isActived: false,
                            },
                            {
                                name: "高效会议",
                                isActived: false,
                            },
                        ]
                    },
                    {
                        id: 4,
                        name: '处理器',
                        isParent: true,
                        isActived: false,
                        list: [
                            {
                                name: "Intel Core",
                                isActived: false,
                            },
                            {
                                name: "Intel Core Ultra",
                                isActived: false,
                            },
                            {
                                name: "AMD Ryzen",
                                isActived: false,
                            },
                            {
                                name: "Intel Xeon",
                                isActived: false,
                            },
                            {
                                name: "AMD EPYC",
                                isActived: false,
                            },
                        ]
                    },
                    {
                        id: 5,
                        name: '特色推荐',
                        isParent: true,
                        isActived: false,
                        list: [
                            {
                                name: "AI PC",
                                isActived: false,
                            },
                            {
                                name: "轻薄精巧",
                                isActived: false,
                            },
                            {
                                name: "高清大屏",
                                isActived: false,
                            },
                            {
                                name: "性能强劲",
                                isActived: false,
                            },
                            {
                                name: "专业设计",
                                isActived: false,
                            },
                        ]
                    },
                ],

                isShowContact: false,
                isShowQrCode: false,

                itemList: [
                    {
                        name: '公众号',
                        img: solution_m_host + "/static/mobile/images/campaign/2023summer/bottom-nav/bottom-nav-icon-8.png",
                        gio: 'eshoph5_footericonclick',
                        url: 'https://www.dellemc-solution.com/eshop/',
                        type: 'gzh',
                    },
                    {
                        name: '会员有礼',
                        img: solution_m_host + '/static/mobile/images/campaign/2023summer/bottom-nav/' + 'bottom-nav-icon-2.png',
                        gio: 'eshoph5_footericonclick',
                        url: 'https://www.dellemc-solution.com/campaign/jump-xcx?path=pages%2Fintegral%2Findex',
                        type: 'url'
                    },
                    {
                        name: '我的礼品',
                        img: solution_m_host + '/static/mobile/images/campaign/2023summer/bottom-nav/' + 'bottom-nav-icon-3.png',
                        gio: 'eshoph5_footericonclick',
                        url: '',
                        type: 'dialog'
                    },
                    {
                        name: '联系客服',
                        img: solution_m_host + '/static/mobile/images/campaign/2023summer/bottom-nav/' + 'bottom-nav-icon-4.png',
                        gio: 'eshoph5_footericonclick',
                        url: '',
                        type: 'kefu'
                    },
                    {
                        name: '电话咨询',
                        img: solution_m_host + '/static/mobile/images/campaign/2023summer/bottom-nav/' + 'bottom-nav-icon-5.png',
                        gio: 'eshoph5_footericonclick',
                        url: '',
                        type: 'tel'
                    },
                    {
                        name: '注册',
                        img: solution_m_host + '/static/mobile/images/campaign/2023summer/bottom-nav/' + 'bottom-nav-icon-6.png',
                        gio: 'eshoph5_footericonclick',
                        url: '',
                        type: 'go'
                    },
                ]
            },
            watch: {
                // 监听表单字段
                isSignUp: function (val) {
                    if (val) {
                        this.$set(this.itemList, 5, {
                            name: '登录',
                            img: solution_m_host + '/static/mobile/images/campaign/2023summer/bottom-nav/' + 'bottom-nav-icon-7.png',
                            gio: 'eshoph5_footericonclick',
                            url: eshop_host + '/account/account',
                            type: 'url'
                        });
                    } else {
                        this.$set(this.itemList, 5, {
                            name: '注册',
                            img: solution_m_host + '/static/mobile/images/campaign/2023summer/bottom-nav/' + 'bottom-nav-icon-6.png',
                            gio: 'eshoph5_footericonclick',
                            url: '',
                            type: 'go'
                        });
                    }
                }
            },
            created: function () {
                var _this = this;
                // 获取表单字段
                memberApi.getRegisterFormDataWithId('1426', function (data) {
                    _this.submitFormData.formId = data.data.formId;
                    _this.formAction = data.data.action;
                    data.data.columns.forEach(function (item) {
                        switch (item.column) {
                            case "mobile" :
                                item.columnName = '手机号';
                                item.myOrder = 6;
                                break;
                            case "name" :
                                item.columnName = '姓名';
                                item.myOrder = 7;
                                break;
                            case "email" :
                                item.columnName = '企业邮箱';
                                item.myOrder = 2;
                                break;
                            case "enterprise_name" :
                                item.columnName = '企业全称';
                                item.myOrder = 3;
                                break;
                            case "password" :
                                item.columnName = '账号密码';
                                item.myOrder = 4;
                                break;
                            case "ifWish" :
                                item.value = "是";
                                item.myOrder = 1;
                                break;
                            case "privacynotice" :
                                item.myOrder = 0;
                                // item.value = item.content[0];
                                break;
                            default:
                                item.myOrder = 0;
                                break;
                        }
                    });
                    data.data.columns.sort(function (a, b) {
                        return b.myOrder - a.myOrder;
                    });
                    _this.formData = data.data.columns;
                    _this.formData.forEach(function (form) {
                        if (form.column == 'mobile') {
                            _this.mobileObject = form;
                        }
                    });
                    $(".loading").hide()
                });
                this.scrollEvent();
                this.setTimeLineStep();
                this.getDrawNumber();
                this.initSwiper();

                this.getNewProduct();
                this.newProductTabList2 = this.newProductTabList[0].list;
            },
            computed: {
                moreChance:function(){ //补全企业邮箱机会
                    return this.count === 0 && !this.verifiedEmail
                },
                // tab选中的是否是服务器
                isServer: function () {
                    var tabObj = this.newProductTabList2.find(function (tab) {
                        return tab.isActived;
                    });
                    return !!tabObj && tabObj.name === '服务器';

                }
            },
            mounted: function () {
                var _this = this;
                // 点击其他地方隐藏弹窗
                document.addEventListener('click', function (e) {
                    _this.hideAllDialog();
                });

                // 滚动时隐藏弹窗
                window.addEventListener('scroll', function (e) {
                    _this.hideAllDialog();
                });
                this.getLuckyData();

                if ($.cookie("smarketMember_498")) {
                    if ($.cookie("smarketMember_498") !== "null" && typeof $.cookie("smarketMember_498") == 'string' ? JSON.parse($.cookie("smarketMember_498")).session : $.cookie("smarketMember_498").session) {
                        this.isSignUp = true;
                        console.log('已登录');
                        this.checkAuth(); // 查询抽奖权限
                    }
                }
                // 获取优惠券列表
                this.getCouponList();
                var platform = '';
                if (common.isXCX()) {
                    platform = '小程序'
                } else if (common.isWx) {
                    platform = '公众号'
                } else {
                    platform = '官网'
                }
                gioTrackAction.gio_base('landingPageView', {
                    'sourcechannel_var': platform,
                });

                this.winningInfor.time = setInterval(this.scroll, 2000);
            },
            methods: {
                // swiper 初始化
                initSwiper: function () {
                    var _this = this;
                    this.$nextTick(function () {
                        _this.mySwiper = new Swiper('.top-box .swiper-container', {
                            autoplay: false,
                            centerInsufficientSlides: true,
                            // 显示6个
                            slidesPerView: 6,
                            // 默认显示第一个
                            initialSlide: 1,
                            // 父级修改了宽度，子级也跟着修改
                            observer: true,
                            observeParents: true,
                            navigation: {
                                nextEl: '.top-box .swiper-button-next',
                                prevEl: '.top-box .swiper-button-prev',
                            },
                        });
                        setTimeout(function () {
                            if ($('#topNav .swiper-container').length) _this.mySwiper.slideTo(0, 10, false); //切换到第一个slide，速度为1秒
                        }, 0)
                    })
                },

                // 点击
                itemClick: function (item) {
                    if (item.gio) {
                        gioTrackAction.gio_base(item.gio, {
                            'iconname': item.name,
                        });
                    }
                    switch (item.type) {
                        case 'gzh':
                            msg.show(document.querySelector('.dialog-box.gzh-dialog'));
                            break;
                        case 'url':
                            common.gotoUrl(item.url);
                            break;
                        case 'dialog':
                            this.openMyPrize();
                            break;
                        case 'kefu':
                            qidiankefu.open(3);
                            break;
                        case 'tel':
                            window.location.href = 'tel:400-884-6610';
                            break;
                        case 'go':
                            this.needLogin();
                            break;
                    }
                },
                hideAllDialog: function () {
                    this.isShowContact = false;
                    this.isShowQrCode = false;
                },
                setTimeLineStep: function () {
                    var _this = this;
                    $.ajax({
                        type: 'GET',
                        url: solution_host + '/api/getSysTime',
                        success: function (data) {
                            var currentTime = data.sysTime;
                            var step1Time = new Date('2024/5/09 23:59:59').getTime() / 1000;
                            var step2Time = new Date('2024/6/10 23:59:59').getTime() / 1000;
                            var step3Time = new Date('2024/6/18 23:59:59').getTime() / 1000;
                            var step4Time = new Date('2024/6/30 23:59:59').getTime() / 1000;
                            if (currentTime <= step1Time) {
                                _this.timeLineStep = 0;
                            } else if (currentTime <= step2Time && currentTime > step1Time) {
                                _this.timeLineStep = 0
                            } else if (currentTime <= step3Time && currentTime > step2Time) {
                                _this.timeLineStep = 1;
                            } else if (currentTime <= step4Time && currentTime > step3Time) {
                                _this.timeLineStep = 2;
                            } else {
                                _this.timeLineStep = 2;
                            }
                        }
                    });
                },
                // 滚动事件, 关闭所有下拉选项
                scrollEvent: function () {
                    var _this = this;
                    window.addEventListener('scroll', function () {
                        _this.formData.forEach(function (form) {
                            form.openOptions = false;
                            if (form.isRelated === 1) {
                                form.content.forEach(function (subform) {
                                    subform.child.openOptions = false;
                                })
                            }
                        })
                    })
                },

                // 输入框输入事件
                inputChangeEvent: function (item) {
                    item.error = false;
                },
                inputBlur: function () {
                    var tampVal
                    this.formData.forEach(function (form) {
                        if (form.column == 'password') {
                            tampVal = form.value
                        }
                    })
                    this.formData.forEach(function (form) {
                        if (form.column == 'password2') {
                            form.value = tampVal
                        }
                    })
                },

                // 下拉选择修改事件
                selectChangeEvent: function (item, option, isRelated) {
                    item.error = false;
                    if (isRelated) {
                        // 下拉级联
                        item.childContent = option.child;
                        item.value = option.name;
                    } else {
                        item.value = option;
                    }
                },

                companyName: function (value) {
                    this.formData.forEach(function (item) {
                        if (item.column === 'enterprise_name') {
                            item.value = value;
                        }
                    });
                },

                // 验证手机号
                vertifUnique: function () {
                    if (this.mobileObject.value) {
                        this.mobileObject.value = this.mobileObject.value.replace(/^\s+|\s+$/g, "");//去掉两头空格;
                    }
                    var unique = this.mobileObject.value;
                    if (!unique || !baseVerif.isMobile(unique)) {
                        // 手机号或者邮箱 无效
                        this.mobileObject.error = true;
                        this.mobileObject.errorText = '请输入正确的手机号';
                        return false;
                    }

                    if (this.mobileObject.error) {
                        return false;
                    }

                    this.mobileObject.error = false;
                    return true;
                },

                // 验证手机号是否注册
                checkUniqueExit: function (form) {
                    if (form.column == 'mobile' && this.vertifUnique()) {
                        var _this = this;
                        memberApi.checkUnique(this.mobileObject.value, function (res) {
                            console.log(res);
                            if (!res.body.content.result) {
                                // 已注册
                                _this.mobileObject.error = true;
                                _this.mobileObject.errorText = '您输入的手机已注册';
                            }
                        })
                    }
                },

                // 验证输入内容
                verifyInputContent: function () {
                    var inputCompelte = true; // 是否输入完成
                    var password = '';
                    var firstErrorColumn = ''; // 第一个输入错误的位置字段
                    var _this = this;
                    this.formData.forEach(function (form, index) {
                        // console.log(form.columnName, '  ---  ' ,form.value, form.errorText);
                        if (form.value && form.value.length > 0) {

                            Vue.set(_this.submitFormData, form.column, form.value)

                            if (form.column === 'mobile' && _this.mobileObject.error) {
                                form.error = true;
                            } else {
                                form.error = false;
                            }


                            if (form.isRelated === 1) {
                                // 是否级联
                                form.content.forEach(function (subForm, subindex) {
                                    if (form.value === subForm.name) {
                                        if (subForm.child.value.length > 0) {
                                            Vue.set(_this.submitFormData, form.column, [form.value, subForm.child.value]);
                                            subForm.child.error = false;
                                        } else if (form.isMust) {
                                            // 如果父级是必填字段，子级也必填
                                            subForm.child.error = true;
                                            inputCompelte = false;
                                        }
                                    }
                                })
                            }
                        } else if (form.isMust) {
                            form.error = true;
                            form.errorText = '请输入' + form.columnName;
                            inputCompelte = false;
                        } else if (form.column == 'privacynotice' && (!form.value || (Array.isArray(form.value) && form.value.length === 0))) {
                            form.error = true;
                            inputCompelte = false;
                        }
                        // 验证码
                        if (form.column === 'mobile' && !_this.isFangyuan) {
                            // 如果不是访员注册，验证码未输入
                            if (!_this.input.code.value.length) {
                                _this.input.code.error = '请输入验证码';
                                firstErrorColumn = "mobile";
                                inputCompelte = false;
                            } else {
                                _this.input.code.error = '';
                                Vue.set(_this.submitFormData, 'checkCode', _this.input.code.value);
                            }
                        }
                        // 邮箱验证
                        if (form.column === 'email' && !baseVerif.isEmail(form.value)) {
                            form.error = true;
                            form.errorText = '请输入正确的邮箱';
                            inputCompelte = false;
                            if (!firstErrorColumn) {
                                firstErrorColumn = "email";
                            }
                        }
                        // 密码
                        if (form.column == 'password') {
                            password = form.value;
                            if (!baseVerif.isPassword(form.value)) {
                                form.error = true;
                                form.errorText = '请输入6~20个字符';
                                inputCompelte = false;
                            } else {
                                form.error = false;
                                form.errorText = '请输入密码';
                            }
                        }
                        if (form.column == 'password2' && form.value) {
                            // 两次密码输入不一致
                            if (form.value != password) {
                                form.error = true;
                                form.errorText = '输入的密码不一致';
                                inputCompelte = false;
                            } else {
                                form.error = false;
                                form.errorText = '请再次确认密码';
                            }
                        }
                        if (form.error && !firstErrorColumn) {
                            firstErrorColumn = form.column;
                        }
                    })
                    console.log(this.formData, this.mobileObject);
                    if (!this.vertifUnique()) {
                        inputCompelte = false;
                    }

                    if (firstErrorColumn) {
                        _this.scrollToErroInput(firstErrorColumn);
                    }

                    return inputCompelte;
                },

                // 滚动至输入错误位置
                scrollToErroInput: function (id) {
                    console.log(id);
                    if ($('#' + id)) {
                        $('html, body').animate({
                            scrollTop: $('#' + id).offset().top - 200
                        })
                    }
                },

                // 发送验证码
                sendSmsCode: function () {
                    if (!this.vertifUnique() || this.isSendSmsing) {
                        return;
                    }
                    // 检查隐私协议是否勾选
                    var privacyNotice = this.formData.find(function(item) {
                        return item.column === 'privacynotice';
                    });
                    if (privacyNotice && (!privacyNotice.value || (Array.isArray(privacyNotice.value) && privacyNotice.value.length === 0))) {
                        // 显示协议同意弹窗
                        this.pendingSendSmsType = 'register';
                        this.isShowPrivacyDialog = true;
                        return;
                    }
                    var _this = this;
                    _this.isSendSmsing = true;
                    memberApi.sendCode(this.mobileObject.value, 'register', function (data) {
                        if (data.errCode == 0) {
                            if (!_this.timer) {
                                _this.timeDown();
                            }
                        } else {
                            _this.mobileObject.error = true;
                            _this.mobileObject.errorText = data.msg;
                        }
                        _this.isSendSmsing = false;
                    }, function (error) {
                        _this.isSendSmsing = false;
                    })

                },

                // 倒计时
                timeDown: function () {
                    var _this = this;
                    _this.downTime = 60;
                    this.timer = setInterval(function () {
                        _this.downTime--;
                        if (_this.downTime == 0) {
                            _this.downTime = '重新发送';
                            clearInterval(_this.timer);
                            _this.timer = null;
                        }
                    }, 1000)
                },

                // 同意协议并发送验证码
                agreePrivacyAndSendCode: function () {
                    var _this = this;
                    var privacyNotices = this.formData.filter(function(item) {
                        return item.column === 'privacynotice';
                    });
                    privacyNotices.forEach(function(notice) {
                        if (!notice.value || (Array.isArray(notice.value) && notice.value.length === 0)) {
                            notice.value = notice.content[0];
                            notice.error = false;
                        }
                    });

                    // 关闭弹窗
                    this.isShowPrivacyDialog = false;

                    // 根据类型发送验证码
                    if (this.pendingSendSmsType === 'register') {
                        // 注册验证码
                        if (!this.vertifUnique() || this.isSendSmsing) {
                            return;
                        }
                        _this.isSendSmsing = true;
                        memberApi.sendCode(this.mobileObject.value, 'register', function (data) {
                            if (data.errCode == 0) {
                                if (!_this.timer) {
                                    _this.timeDown();
                                }
                            } else {
                                _this.mobileObject.error = true;
                                _this.mobileObject.errorText = data.msg;
                            }
                            _this.isSendSmsing = false;
                        }, function (error) {
                            _this.isSendSmsing = false;
                        });
                    }

                    // 清空待发送类型
                    this.pendingSendSmsType = '';
                },

                // 注册按钮
                submit: function () {
                    if (!this.verifyInputContent() || this.isSubmiting) {
                        return;
                    }
                    var _this = this;
                    this.isSubmiting = true;
                    // 验证码是否正确
                    if (_this.isFangyuan) {
                        regist();
                    } else {
                        memberApi.checkSmsCode(this.submitFormData.mobile, this.submitFormData.checkCode, 'register', function (data) {
                            if (data.body.result == 0) {
                                regist();
                            } else {
                                _this.input.code.error = data.body.desc;
                                _this.isSubmiting = false;
                                _this.scrollToErroInput('checkCode')
                            }
                        }, function () {
                            _this.isSubmiting = false;
                        })
                    }

                    function regist() {
                        _this.submitFormData.password = md5(_this.submitFormData.password).toUpperCase();
                        _this.submitFormData.globalUserId = getCookie('globalUserId').replace(/"/g, "")
                        var mobile = _this.mobileObject.value;
                        _this.submitFormData.linksourcemodule = window.cateData.pageModule;

                        _this.submitFormData.utmSource = utmObj.utm_source;
                        _this.submitFormData.utmMedium = utmObj.utm_medium;
                        _this.submitFormData.utmCampaign = utmObj.utm_campaign;
                        _this.submitFormData.utmContent = utmObj.utm_content;
                        _this.submitFormData.utmTerm = utmObj.utm_term;
                        _this.submitFormData.moduleSources = window.cateData.pageModule;

                        memberApi.regist(_this.submitFormData, function (data) {
                            if (data.errCode == 0) {
                                // 用户行为
                                userRecode({behaviorType: '注册', behaviorResult: '注册成功'});
                                //cookie中设置一个用户手机
                                $.cookie('Activity_MOBILE', 'MOBILE' + mobile + 'number', {
                                    expires: 365,
                                    path: '/',
                                    domain: window.location.host
                                });
                                gioTrackAction.gio_base('memberjoin_summersubmit', {
                                    'userName': _this.submitFormData.name,
                                    'phoneNumber': _this.submitFormData.mobile,
                                    'company': _this.submitFormData.enterprise_name,
                                    'submit618_type': 'new',
                                    'email': _this.submitFormData.email,
                                    'ifMatchingcompanyName': window.ifMatchingcompanyName,
                                });
                                gioTrackAction.gio_base('registerSuccess', {
                                    'userName': _this.submitFormData.name,
                                    'phoneNumber': _this.submitFormData.mobile,
                                    'company': _this.submitFormData.enterprise_name,
                                    'email': _this.submitFormData.email,
                                });
                                gio('track', 'loginSuccess', {
                                    'user_Id': data.data.loginId,
                                    'phoneNumber': common.mobileGioEncryption(_this.submitFormData.mobile),
                                    'loginType': '短信'
                                });

                                _this.getCouponList();
                                _this.checkAuth();

                                // msg.toast('恭喜您已获得暑期促销活动会员专享资质!');
                                setTimeout(function () {
                                    // window.location.href = data.data.redirect || _this.backUrl || window.location.origin;
                                    _this.isSignUp = true;
                                    var postData = {
                                        "userId": data.data.loginId,
                                        "name": _this.submitFormData.name,
                                        "mobile": _this.submitFormData.mobile,
                                        "email": _this.submitFormData.email,
                                        "company": _this.submitFormData.enterprise_name,
                                        "utmSource": utmObj.utm_source,
                                        "utmMedium": utmObj.utm_medium,
                                        "utmCampaign": utmObj.utm_campaign,
                                        "utmContent": utmObj.utm_content,
                                        "utmTerm": utmObj.utm_term,
                                        "interests": getCookie('interests') || '',
                                        "utmModule": window.cateData.userRecodeOption.title,
                                        "formTitle": window.cateData.userRecodeOption.title
                                    };
                                    _this.sendCurrentData(postData);
                                }, 100);
                                setCookie('2020summerlottery', '1');
                            } else {
                                userRecode({behaviorType: '注册', behaviorResult: '注册失败'});
                                msg.toast(data.msg);
                                _this.isSubmiting = false;
                                if (data.msg === '唯一字段重复：邮箱') {
                                    // 邮箱已注册
                                    _this.formData.forEach(function (form, index) {
                                        if (form.column === 'email') {
                                            form.error = true;
                                            form.errorText = '邮箱已注册';
                                        }
                                    })
                                    _this.scrollToErroInput('email');
                                }
                            }
                        }, function (err) {
                            userRecode({behaviorType: '注册', behaviorResult: '注册失败'});
                            _this.isSubmiting = false;
                        })
                    }
                },

                // 退出按钮
                logout: function () {
                    this.isSignUp = false;
                    this.isRegisterShow = false;
                    common.loginOut(false, function () {});
                },

                /*登录注册成功把信息提交后台*/
                sendCurrentData: function (data) {
                    this.formUserInfo = data;

                    // 飞鱼推广数据
                    data.adid = common.getUrlPara('adid') || '';
                    data.clickid = common.getUrlPara('clickid') || '';
                    data.creativeid = common.getUrlPara('creativeid') || '';
                    data.creativetype = common.getUrlPara('creativetype') || '';

                    // 快手推广数据
                    data.aid = common.getUrlPara('aid') || '';
                    data.callback = common.getUrlPara('callback') || '';

                    if (common.getUrlPara('card_id')) {
                        data.card_id = common.getUrlPara('card_id');
                    }
                    console.log("addcustomer",data);

                    $.ajax({
                        url: solution_host + "/api/campaign/addcustomer",
                        method: 'POST',
                        data: data,
                        success: function (res) {
                        },
                        error: function (error) {
                        }
                    });
                },

                // 验证手机号--登录
                vertifUniqueLogin: function () {
                    if (this.input2.unique.value) {
                        this.input2.unique.value = this.input2.unique.value.replace(/^\s+|\s+$/g, "");//去掉两头空格;
                    }
                    var unique = this.input2.unique.value;
                    if (!baseVerif.isMobile(unique) && !baseVerif.isEmail(unique)) {
                        // 手机号或者邮箱 无效
                        this.input2.unique.error = '请输入正确的手机号';
                        this.errorInfo = this.input2.unique.error;
                        return false;
                    }

                    this.input2.unique.error = ''
                    this.errorInfo = this.input2.unique.error;
                    return true;
                },

                // 验证验证码
                vertifyCode: function () {
                    if (!this.input2.smsCode.value) {
                        this.input2.smsCode.error = '请输入验证码';
                    } else {
                        this.input2.smsCode.error = '';
                    }

                    this.errorInfo = this.input2.smsCode.error;
                    return this.errorInfo.length > 0 ? false : true;
                },

                // 发送验证码
                sendSmsCodeLogin: function () {
                    if (!this.vertifUniqueLogin() || this.timer || this.downTime == '发送中...') {
                        // 验证不通过，或者正在倒计时
                        return;
                    }
                    var _this = this;

                    memberApi.checkUnique(this.input2.unique.value, function (res) {
                        console.log(res);
                        if (!res.body.content.result) {
                            // 已注册
                            send();
                        } else {
                            _this.isRegisterShow = true;
                            _this.input2.unique.error = '账号或密码错误';
                            _this.errorInfo = _this.input2.unique.error;
                            console.log(_this.formData)
                            _this.formData.forEach(function (obj) {
                                if (obj.column == 'mobile') {
                                    obj.value = _this.input2.unique.value;
                                    obj.error = false;
                                }
                            })
                        }
                    })

                    function send() {
                        _this.smsCodeSended = true;
                        _this.downTime = '发送中...';
                        memberApi.sendCode(_this.input2.unique.value, 'login', function (data) {
                            if (data.errCode === 0) {
                                if (!_this.timer) {
                                    _this.timeDown();
                                }
                            } else {
                                _this.errorInfo = data.msg;
                                _this.downTime = '重新发送'
                            }
                        })
                    }
                },

                // 登录按钮
                login: function () {
                    if (!this.vertifUniqueLogin() || this.logining) {
                        return;
                    }
                    if (!this.vertifyCode()) {
                        return;
                    }

                    var _this = this;

                    memberApi.checkUnique(this.input2.unique.value, function (res) {
                        console.log(res);
                        if (!res.body.content.result) {
                            // 已注册
                            loginEvent();
                        } else {
                            _this.input2.unique.error = '账号或密码错误';
                            _this.errorInfo = _this.input2.unique.error;
                        }
                    })

                    function loginEvent() {
                        _this.logining = true;
                        memberApi.login(_this.input2.unique.value,
                            '',
                            _this.input2.smsCode.value,
                            function (data) {
                                if (data.errCode === 0) {
                                    data = data.data;
                                    try {
                                        // gio 埋码
                                        var giouserinfo = data.info;
                                        gioTrackAction.gio_base('memberjoin_summersubmit', {
                                            'userName': giouserinfo.name,
                                            'phoneNumber': giouserinfo.mobile,
                                            'company': giouserinfo.enterprise_name,
                                            'submit618_type': 'old',
                                            'email': giouserinfo.email,
                                            "utmSource": utmObj.utm_source,
                                            "utmMedium": utmObj.utm_medium,
                                            "utmCampaign": utmObj.utm_campaign,
                                            "utmContent": utmObj.utm_content,
                                            "utmTerm": utmObj.utm_term,
                                            "interests": getCookie('interests') || '',
                                            "utmModule": window.cateData.userRecodeOption.title,
                                            "formTitle": window.cateData.userRecodeOption.title
                                        });
                                        gio('track', 'loginSuccess', {
                                            'user_Id': data.memberId,
                                            'phoneNumber': common.mobileGioEncryption(giouserinfo.mobile)
                                        });


                                        //小网埋码需要存此cookie
                                        // $.cookie('DS_ACCOUNT_ID', data.memberId, {
                                        //     expires: 30,
                                        //     path: '/',
                                        //     domain: window.location.host
                                        // });
                                        userRecode({behaviorType: '登录', behaviorResult: '登录成功'});

                                    } catch (e) {
                                        console.log(e);
                                    }
                                    // msg.toast('恭喜您已获得暑期促销活动会员专享资质!');
                                    _this.isSignUp = true;
                                    _this.logining = false;
                                    var myInfo = data.info;
                                    var postData = {
                                        "userId": data.loginId,
                                        "name": myInfo.name,
                                        "mobile": myInfo.mobile,
                                        "email": myInfo.email,
                                        "company": myInfo.enterprise_name,
                                        "utmSource": utmObj.utm_source,
                                        "utmMedium": utmObj.utm_medium,
                                        "utmCampaign": utmObj.utm_campaign,
                                        "utmContent": utmObj.utm_content,
                                        "utmTerm": utmObj.utm_term,
                                        "interests": getCookie('interests') || '',
                                        "utmModule": window.cateData.userRecodeOption.title,
                                        "formTitle": window.cateData.userRecodeOption.title
                                    }
                                    _this.sendCurrentData(postData);
                                    setCookie('2020summerlottery', '1');
                                    _this.getCouponList();
                                    _this.checkAuth();
                                    getUserInfo.updateUserInfo();
                                } else {
                                    userRecode({behaviorType: '登录', behaviorResult: '登录失败'});
                                    _this.errorInfo = data.msg;
                                    msg.toast(data.msg);
                                }
                                _this.logining = false;
                            }, function () {
                                userRecode({behaviorType: '登录', behaviorResult: '登录失败'});
                            }
                        )
                    }

                },

                // 跳转至登录模块位置
                needLogin: function () {
                    if (common.isM) {
                        $('html, body').animate({
                            scrollTop: $('.pos-registration').offset().top - 90
                        });
                    } else {
                        $('html, body').animate({
                            scrollTop: $('.hd-part-box-bg').offset().top
                        });
                    }
                    msg.toast('请注册或登录');
                },

                // 封装函数 跳转至url、点击埋码
                toLink: function (url, gioTag) {
                    if (gioTag) {
                        gioTrackAction.gio_base(gioTag);
                    }
                    if (!this.isSignUp) {
                        this.needLogin();
                        return;
                    }
                    if (!url) {
                        return;
                    }
                    if (window.cateData.device == 'pc') {
                        window.open(url);
                    } else {
                        window.location.href = url;
                    }
                },

                // 跳转到产品详情页
                toProductDetail: function (url, title, model, type) {
                    gioTrackAction.gio_base('eshopsummer2021_productClick', {
                        'productModel': title,
                        'product_lob': type ? type : this.newProductTabList2.find(function (tab) {
                            return tab.isActived;
                        }).name,
                        'eshop_Productnumber_cms': model
                    });
                    this.toLink(url);
                },

                // 打开起点客服
                toQiDianServer: function () {
                    gioTrackAction.gio_base('qiyedingzhi_saleschatclick');
                    qidiankefu.open(3, {'moduleName': window.cateData.userRecodeOption.module});
                },

                // 跳转到注册模块
                isRegisterClick: function () {
                    this.isRegisterShow = true;
                    setTimeout(function () {
                        new selectCompany('#enterprise_name input')
                    }, 2000)
                },

                // 免费抽奖
                toLottery: function () {
                    // wap端
                    if (common.isM) {
                        $('html, body').animate({
                            scrollTop: $('.pos-lottery').offset().top - 100
                        });
                    } else {
                        $('html, body').animate({
                            scrollTop: $('.hd-form-box').offset().top - 200
                        });
                    }
                    gioTrackAction.gio_base('double11_0choujiang');
                },

                // 0元试用
                toFreeUse: function () {
                    var url = "https://www.dellemc-solution.com/campaigns/try/pc/#/home";
                    this.toLink(url, 'promotion_0yuantry');
                },

                // 存储折扣页
                toStorage: function () {
                    var url = solution_host + "/campaign/storage-promotion";
                    this.toLink(url, 'promotion_0yuantry');
                },

                // AI PC新品上市页
                toAipc: function () {
                    var url = solution_host + "/latest-dell-products";
                    this.toLink(url, 'eshopnewproduct');
                },

                // 1元秒杀
                gotoMiaosha: function () {
                    // return msg.toast('活动暂未开始，敬请期待');
                    // return this.isShowMiaoshaTip = true;
                    gioTrackAction.gio_base('double11_miaoshao');
                    window.open("https://m.dellemc-solution.com/miaosha");
                },

                // 618幸运大礼
                toLuckyGift: function () {
                    gioTrackAction.gio_base('eshoppromotion_618click');
                    common.gotoUrl('https://m.dellemc-solution.com/campaign/luckdraw618');
                    // msg.toast("618返场升级【即将上线】，" +
                    //     "幸运大礼包将于6月19日开启，" +
                    //     "敬请期待");
                },

                // 资产回收
                toRenew: function () {
                    var url = solution_host + '/campaign/trade-in';
                    this.toLink(url, 'eshoppromotion_Click_huanxin');
                },

                // 万元服务
                toReport: function () {
                    var url = 'https://www.dellemc-solution.com/campaigns/try/pc/?pos=service-try#/home';
                    this.toLink(url, 'eshoppromotion_Click_wanyuanfuwu');
                },

                // 千元大礼
                toQianyuan: function () {
                    gioTrackAction.gio_base('promotion_qianyuandali');
                    if (this.isSignUp) {
                        if (common.isXCX()) {
                            return common.gotoXCX('/pages/shop/couponIndex')
                        }
                        window.open("https://www.dellemc-solution.com/campaign/coupon/index");
                    } else {
                        this.needLogin();
                    }
                },

                // 会员积分点击
                toMember: function () {
                    // 显示确认弹窗
                    this.isShowExchangeModal = true;
                    gioTrackAction.gio_base('eshoppromotion_jifenclick');
                    //禁止后方滚动
                    setScroll.unScroll();
                },


                /*原厂巡检*/
                goYuanchangxunjian: function () {
                    var url = 'https://www.dellemc-solution.com/campaigns/inspection/';
                    this.toLink(url, 'eshoppromotion_Click_yuanchangxunjian');
                },

                // 新人有礼
                toNewGift: function () {
                    var url = 'https://www.dellemc-solution.com/eshop/';
                    this.toLink(url, 'eshoppromotion_Click_xinrenyouli');
                },

                /*意外险*/
                goYiwaixian: function () {
                    var url = 'https://www.dellemc-solution.com/campaigns/casualty/';
                    this.toLink(url, 'eshoppromotion_Click_yiwaixian');
                },

                goShop: function () {
                    var url = 'https://www.dellemc-solution.com/eshop/';
                    this.toLink(url, 'eshoppromotion_Click_maijizeng');
                },

                // 延保增配
                toPosUpgrade: function () {
                    $('html, body').animate({
                        scrollTop: $('.pos-upgrade').offset().top - 30
                    });
                    gioTrackAction.gio_base('eshoppromotion_Click_yanbao');
                },
                goDell: function () {
                    window.open("https://www.dellemc-solution.com/");
                },
                //判断是不是首次登录
                checkIsFrist: function (successCallback) {
                    var url = '/api/';
                    memberApi.api(url, null, function (data) {
                        successCallback(data);
                    })
                },

                // 积分功能
                // 获取优惠券列表
                getCouponList: function () {
                    var _this = this;

                    var info = {
                        session: common.isLogin().session,
                        OCSESSID: common.isLogin().OCSESSID,
                        no: 32,
                        test: 1
                    }

                    common.getJson(solution_host + '/api/points/getPointsItems', info, function (res) {
                        if (res.errCode === 0) {
                            _this.coupons = res.data
                            _this.$nextTick(function () {
                                _this.initCouponSwiper();
                            })
                        }
                    })
                },

                // 点击兑换
                exchangeEvent: function (coupon) {
                    // 显示确认弹窗
                    this.isShowExchangeModal = true;
                    gioTrackAction.gio_base('promotioncoupon_click', {
                        'eshopcoupon_title': coupon.short_title,
                    });
                    //禁止后方滚动
                    setScroll.unScroll();
                },

                initCouponSwiper: function () {

                    var slidesNum = 3;

                    if (cateData.device === 'wap') {
                        slidesNum = 2;
                    }

                    this.couponSwiper = new Swiper('.jifen-list', {
                        loop: false,
                        slidesPerView: slidesNum,
                        slidesPerGroup: slidesNum,
                        spaceBetween: slidesNum,
                        // autoplay: {
                        //     delay: 3000,
                        //     stopOnLastSlide: false,
                        //     disableOnInteraction: false,
                        // },
                        disableOnInteraction: false,
                        navigation: {
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev',
                        }
                    });
                },
                gotoCouponUrl: function (url) {
                    common.gotoUrl(url);
                },

                // 秒杀敬请期待
                miaoshaTips: function () {
                    this.isShowFanchangModal = true;
                    //禁止后方滚动
                    setScroll.unScroll();
                },
                wapFanChang: function(){
                    window.location.href = 'https://www.dellemc-solution.com/campaign/jump-xcx?path=pages%2Fintegral%2Findex&query=utm_source%3Dcampaign%26utm_medium%3Dother%26utm_campaign%3Dmember_fy24q41114%26utm_content%3Dmona-li%26utm_term%3Dfanchanghaoli'
                },
                closeExchangeDialog: function () {
                    this.isShowExchangeModal = false;
                    setScroll.removeUnScroll();
                },
                closeMiaoshaDialog: function () {
                    this.isShowMiaoshaTip = false;
                    setScroll.removeUnScroll();
                },
                closeFanchangDialog: function () {
                    this.isShowFanchangModal = false;
                    setScroll.removeUnScroll();
                },
                // 右侧注册有礼埋点
                rightBarRegGio: function () {
                    if (common.isLogin()) {
                        gioTrackAction.gio_base('eshoppromotion_rightfloat_mycenter')
                    } else {
                        gioTrackAction.gio_base('eshoppromotion_rightfloat_reg')
                    }
                },

                //视频弹窗
                video: function (url, title) {
                    common.showVideo({
                        url: url, //文件url
                        title: title, //文件名称
                    })
                },

                // 抽奖模块
                initLucky: function () {
                    var that = this;
                    that.myLucky = new LuckyCanvas.LuckyWheel('#my-lucky', {
                        width: common.isM ? '6.7rem' : (window.width_type === 'note' ? '340px' : '460px'),
                        height: common.isM ? '6.7rem' : (window.width_type === 'note' ? '340px' : '460px'),
                        blocks: [{
                            imgs: [{
                                src: '/static/pc/img/campaign/2026spring/turntable.gif?v=1',
                                width: '100%',
                                height: '100%',
                                rotate: true,
                            }]
                        }],
                        prizes: that.prizes,
                        buttons: [
                            {
                                radius: '45%',
                                imgs: [{
                                    src: '/static/pc/img/campaign/2026spring/pointer.png',
                                    width: '46%',
                                    top: '-70%'
                                }]
                            },
                        ],
                        start: function () {
                            that.draw();
                        },
                        end: function (prize) {
                            console.log('endCallback', prize);
                            that.showPrizePop = true;
                            that.isDrawing = false;
                            setScroll.unScroll();
                        }
                    })
                },
                draw: function () {
                    if (this.isDrawing) {
                        return;
                    }

                    if (!this.isEnable) {
                        msg.toast('活动已结束');
                        return;
                    }

                    if (!common.isLogin()) {
                        this.needLogin();
                        return;
                    }


                    // 判断是否补全信息
                    if (!getUserInfo.options.email || !getUserInfo.options.name || getUserInfo.options.enterprise) {
                        msg.completeDialog(function (){
                            getUserInfo.updateUserInfo()
                            msg.toast('提交成功！');
                        });
                        return;
                    }

                    // 补全邮箱增加抽奖机会 未填写企业邮箱并且抽奖次数为0
                    if (!this.verifiedEmail && this.count === 0) {
                        this.isShowEmailDialog = true; //显示补全邮箱弹窗
                        return;
                    }
                    // 没有抽奖机会了
                    if (this.count === 0) {
                        this.showOverTip = true; //显示没有抽奖机会的弹窗
                        return;
                    }

                    msg.loading().show();

                    this.isDrawing = true;
                    var that = this;
                    common.postJson(solution_host + '/api/lucky/draw', {
                        eventId: that.eventId,
                        source: common.isM ? 'wap' : 'pc',
                        session: common.isLogin().session,
                        OCSESSID: common.isLogin().OCSESSID,
                    }, function (res) {
                        if (res.errCode === 0) {
                            that.winPrize = res.data;
                            that.prizesList.map(function (item, index) {
                                if (item.name === res.data.prizeName) {
                                    that.prizeIndex = index;
                                    that.startCallback();
                                }
                            });
                            gioTrackAction.gio_base('lotterySuccess', {
                                'prizeName': that.winPrize.prizeName,
                                'lotteryType': that.verifiedEmail? '补充邮箱2次' : '首次',
                            });
                            that.auth = -1;
                            that.checkAuth();
                        } else {
                            that.isDrawing = false;
                            msg.toast(res.msg);
                        }
                        msg.loading().close();
                    });
                },
                // 点击抽奖按钮会触发star回调
                startCallback: function () {
                    var that = this;
                    // 调用抽奖组件的play方法开始游戏
                    that.myLucky.play();
                    // 模拟调用接口异步抽奖
                    setTimeout(function () {
                        // 调用stop停止旋转并传递中奖索引
                        that.myLucky.stop(that.prizeIndex);
                    }, 3000)
                },
                // 查询抽奖权限
                checkAuth: function () {
                    var that = this;
                    common.getJson(solution_host + '/api/lucky/drawauth', {
                        eventId: that.eventId,
                        session: common.isLogin().session,
                        OCSESSID: common.isLogin().OCSESSID,
                    }, function (res) {
                        that.count = res.data.count?res.data.count:0; //剩余抽奖次数
                        that.verifiedEmail = res.data.verifiedEmail; //是否填写过企业邮箱

                         // 自动弹出邮箱补全弹窗的逻辑
                        that.autoShowEmailDialog();
                    });
                },

                // 自动弹出邮箱补全弹窗
                autoShowEmailDialog: function () {
                    var that = this;
                    var checkCount = 0;
                    var maxChecks = 20; // 最多检查20次

                    // 检查一天内弹窗次数限制
                    function checkDailyLimit() {
                        try {
                            var today = new Date().toDateString(); // 获取今天的日期字符串
                            var storageKey = 'emailDialog_data';
                            var dialogData = JSON.parse(localStorage.getItem(storageKey) || '{}');

                            // 清理过期数据（保留最近7天的数据）
                            cleanOldData(dialogData);

                            var todayCount = dialogData[today] || 0;

                            // 如果今天已经弹出2次，则不再弹出
                            if (todayCount >= 2) {
                                return false;
                            }
                            return true;
                        } catch (e) {
                            // localStorage异常时，允许弹出（降级处理）
                            console.warn('localStorage error:', e);
                            return true;
                        }
                    }

                    // 清理过期数据
                    function cleanOldData(dialogData) {
                        var now = new Date();
                        var sevenDaysAgo = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
                        var hasDeleted = false;

                        for (var date in dialogData) {
                            if (new Date(date) < sevenDaysAgo) {
                                delete dialogData[date];
                                hasDeleted = true;
                            }
                        }

                        // 如果有删除操作，更新localStorage
                        if (hasDeleted) {
                            try {
                                localStorage.setItem('emailDialog_data', JSON.stringify(dialogData));
                            } catch (e) {
                                console.warn('localStorage update error:', e);
                            }
                        }
                    }

                    // 记录弹窗次数
                    function recordDialogShow() {
                        try {
                            var today = new Date().toDateString();
                            var storageKey = 'emailDialog_data';
                            var dialogData = JSON.parse(localStorage.getItem(storageKey) || '{}');

                            // 清理过期数据
                            cleanOldData(dialogData);

                            // 更新今天的计数
                            dialogData[today] = (dialogData[today] || 0) + 1;

                            localStorage.setItem(storageKey, JSON.stringify(dialogData));
                        } catch (e) {
                            // localStorage异常时，静默失败
                            console.warn('localStorage error:', e);
                        }
                    }

                    // 设置轮询标志位
                    that.emailDialogPolling = true;

                    // 循环检查函数
                    function checkAndShow() {
                        // 检查是否需要停止轮询
                        if (!that.emailDialogPolling) {
                            return; // 停止轮询
                        }

                        // 0、检查一天内弹窗次数限制
                        if (!checkDailyLimit()) {
                            that.emailDialogPolling = false; // 达到每日限制，停止轮询
                            return;
                        }

                        // 1、判断没有其他弹框出现的情况
                        var hasOtherDialog = that.isShowExchangeModal || that.isShowRedBackModal ||
                            that.isShowMiaoshaTip || that.isShowFanchangModal ||
                            that.isShowAddressModal || that.showOverTip ||
                            that.showPrizePop || that.isShowMyPrize ||
                            that.isShowMyPrizeHongbao || that.winningInforDialog ||
                            that.isDrawing; // 添加抽奖进行中的判断

                        // 2、判断用户抽奖没有机会了
                        var noChance = that.count === 0;

                        // 3、判断用户没有补全邮箱
                        var notVerifiedEmail = !that.verifiedEmail;

                        // 4、判断用户已经进行过至少一次抽奖（避免第一次进入页面就弹出）
                        var hasDrawnBefore = that.auth !== undefined && that.auth !== null;

                        // 5、自动弹出补全弹窗（只有在用户已经抽过奖且没有机会时才弹出）
                        if (!hasOtherDialog && noChance && notVerifiedEmail && hasDrawnBefore) {
                            that.isShowEmailDialog = true;
                            recordDialogShow(); // 记录弹窗次数
                            that.emailDialogPolling = false; // 成功弹出后停止轮询
                            return; // 成功弹出，停止循环
                        }

                        // 如果条件不满足且未达到最大检查次数，继续检查
                        checkCount++;
                        if (checkCount < maxChecks) {
                            setTimeout(checkAndShow, 5000); // 5秒后再次检查
                        } else {
                            that.emailDialogPolling = false; // 达到最大检查次数，停止轮询
                        }
                    }

                    // 开始检查
                    checkAndShow();
                },
                // 获取抽奖活动信息
                getLuckyData: function () {
                    var that = this;
                    common.getJson(solution_host + '/api/lucky/get', {
                        eventId: this.eventId,
                    }, function (res) {
                        if (res.errCode === 0) {
                            that.isEnable = res.data.isEnable;
                            that.prizesList = res.data.prizes;
                            var tempArr = [];
                            res.data.prizes.map(function (item) {
                                tempArr.push({
                                    range: null,
                                    imgs: [{
                                        src: '/static/mobile/images/campaign/2023spring/block.png', //插入空白图片，抽奖插件只计算奖品数量即可，奖品显示在背景上
                                        width: '40%',
                                        top: '50%'
                                    }]
                                });
                            });
                            that.prizes = tempArr;
                            that.initLucky();
                        } else {
                            msg.toast('请重新打开页面');
                        }
                    });
                },
                // 获取抽奖人数
                getDrawNumber: function () {
                    var _this = this;
                    common.getJson(solution_host + '/api/lucky/onlineNum?eventId=' + this.eventId, '', function (res) {
                        _this.drawNumber = res.data.num;
                    })
                },

                // 抽奖名单滚动
                scroll: function () {
                    var _this = this;
                    var con1 = this.$refs.con1;
                    var scrollT = $('#con1 li').height() * 3;
                    if (_this.winningInfor.list.length > 3 && con1) {

                        con1.style.marginTop = '-' + scrollT + 'px';
                        this.winningInfor.animate = !this.winningInfor.animate;

                        setTimeout(function () {
                            _this.winningInfor.list.push(_this.winningInfor.list[0],_this.winningInfor.list[1],_this.winningInfor.list[2]);
                            _this.winningInfor.list.shift();
                            _this.winningInfor.list.shift();
                            _this.winningInfor.list.shift();
                            con1.style.marginTop = "0px";
                            _this.winningInfor.animate = !_this.winningInfor.animate;
                        }, 1000);
                    }
                },
                goAgain: function () {
                    this.showPrizePop = false;
                    this.isShowEmailDialog = true;
                },
                showAddress: function (item) {
                    this.isShowMyPrize = false;
                    this.showPrizePop = false;
                    if(item){
                        this.winPrize.id = item.id;
                    }
                    this.isShowAddressModal = true;
                },
                verifyAddress: function (field) {
                    // 单个字段验证
                    if (field) {
                        // 重置错误状态
                        field.error = false;

                        // 验证手机号格式
                        if (field.label === 'mobile') {
                            if (!field.value) {
                                field.error = true;
                                msg.toast('请输入手机号');
                                return false;
                            } else if (!baseVerif.isMobile(field.value)) {
                                field.error = true;
                                msg.toast('请输入正确的手机号');
                                return false;
                            }
                        }
                        // 验证姓名
                        else if (field.label === 'name') {
                            if (!field.value) {
                                field.error = true;
                                msg.toast('请输入姓名');
                                return false;
                            } else if (field.value.length < 2) {
                                field.error = true;
                                msg.toast('姓名长度不能少于2个字符');
                                return false;
                            }
                        }
                        // 验证地址
                        else if (field.label === 'address') {
                            if (!field.value) {
                                field.error = true;
                                msg.toast('请输入地址');
                                return false;
                            } else if (field.value.length < 5) {
                                field.error = true;
                                msg.toast('地址长度不能少于5个字符');
                                return false;
                            }
                        }
                        // 验证其他必填字段
                        else if (!field.value) {
                            field.error = true;
                            msg.toast('请输入' + field.labelText);
                            return false;
                        }

                        return true;
                    }

                    // 所有字段验证
                    var error = true;
                    var firstError = false;

                    for (var key in this.addressField) {
                        var field = this.addressField[key];
                        field.error = false;

                        // 验证手机号
                        if (key === 'mobile') {
                            if (!field.value) {
                                field.error = true;
                                error = false;
                                if (!firstError) {
                                    msg.toast('请输入手机号');
                                    firstError = true;
                                }
                            } else if (!baseVerif.isMobile(field.value)) {
                                field.error = true;
                                error = false;
                                if (!firstError) {
                                    msg.toast('请输入正确的手机号');
                                    firstError = true;
                                }
                            }
                        }
                        // 验证姓名
                        else if (key === 'name') {
                            if (!field.value) {
                                field.error = true;
                                error = false;
                                if (!firstError) {
                                    msg.toast('请输入姓名');
                                    firstError = true;
                                }
                            } else if (field.value.length < 2) {
                                field.error = true;
                                error = false;
                                if (!firstError) {
                                    msg.toast('姓名长度不能少于2个字符');
                                    firstError = true;
                                }
                            }
                        }
                        // 验证地址
                        else if (key === 'address') {
                            if (!field.value) {
                                field.error = true;
                                error = false;
                                if (!firstError) {
                                    msg.toast('请输入地址');
                                    firstError = true;
                                }
                            } else if (field.value.length < 5) {
                                field.error = true;
                                error = false;
                                if (!firstError) {
                                    msg.toast('地址长度不能少于5个字符');
                                    firstError = true;
                                }
                            }
                        }
                        // 验证其他必填字段
                        else if (!field.value) {
                            field.error = true;
                            error = false;
                            if (!firstError) {
                                msg.toast('请输入' + field.labelText);
                                firstError = true;
                            }
                        }
                    }

                    return error;
                },
                // 抽奖 实物填写地址
                addressShow: function () {
                    if (!this.verifyAddress()) return;
                    common.postJson(solution_host + '/api/lucky/addaddress', {
                        session: common.isLogin().session,
                        OCSESSID: common.isLogin().OCSESSID,
                        lid: this.winPrize.id,
                        name: this.addressField.name.value,
                        mobile: this.addressField.mobile.value,
                        address: this.addressField.address.value,
                        company: this.addressField.company.value,
                    }, function (res) {
                        if(res.errCode === 0){
                            msg.toast('提交成功')
                        }else {
                            msg.toast(res.msg);
                        }
                    });
                    // 关闭弹窗
                    this.closeLuckDialog();
                },
                // 倒计时
                timeDownEmail: function () {
                    var _this = this;
                    _this.emailInput.downTime = 60;
                    this.emailInput.timer = setInterval(function () {
                        _this.emailInput.downTime--;
                        if (_this.emailInput.downTime == 0) {
                            _this.emailInput.downTime = '重新发送';
                            clearInterval(_this.emailInput.timer);
                            _this.emailInput.timer = null;
                        }
                    }, 1000)
                },
                vertifEmail: function () {
                    if (!this.emailInput.unique.value) {
                        this.emailInput.unique.error = '请输入企业邮箱';
                        return false;
                    }
                    var email = /^([a-zA-Z0-9][a-zA-Z0-9._-]+)@([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,4}$/; //邮箱
                    if (!email.test(this.emailInput.unique.value.trim())) {
                        this.emailInput.unique.error = '企业邮箱格式不正确';
                        return false;
                    }
                    this.emailInput.unique.error = '';
                    return true;
                },
                // 发送验证码
                sendEmailCodeLogin: function () {
                    if (!this.vertifEmail() || this.emailInput.timer || this.emailInput.downTime === '发送中...') return;
                    var _this = this;
                    _this.emailInput.smsCodeSended = true;
                    _this.emailInput.downTime = '发送中...';
                    common.postJson(solution_host + '/api/edm/verifyCode/send', {
                        email: this.emailInput.unique.value,
                    }, function (res) {
                        if (res.errCode === 0) {
                            _this.timeDownEmail();
                        } else {
                            msg.toast(res.msg);
                            _this.emailInput.downTime = '重新发送'
                        }
                    });
                },
                // 验证验证码
                vertifyEmailCode: function () {
                    if (!this.emailInput.smsCode.value) {
                        this.emailInput.smsCode.error = '请输入验证码';
                    } else {
                        this.emailInput.smsCode.error = '';
                    }
                    return !!!this.emailInput.smsCode.error;
                },
                emailSubmit: function () {
                    var that = this;
                    if (this.vertifyEmailCode()) {
                        common.postJson(solution_host + '/api/lucky/more', {
                            eventId: this.eventId,
                            code: this.emailInput.smsCode.value,
                            email: this.emailInput.unique.value,
                            session: common.isLogin().session,
                            OCSESSID: common.isLogin().OCSESSID,
                        }, function (res) {
                            if (res.errCode === 0) {
                                that.isShowEmailDialog = false;
                                that.checkAuth();
                                msg.toast('恭喜您获得第2次抽奖机会');
                                gioTrackAction.gio_base('emailVerificationSuccess', {
                                    'emailupdate': that.emailInput.unique.value,
                                });
                            } else {
                                that.emailInput.smsCode.error = res.msg
                            }
                        });
                    }
                },
                closeLuckDialog: function () {
                     // 停止邮箱补全弹窗的轮询判断
                    if (this.isShowEmailDialog) this.emailDialogPolling = false;
                    this.isShowAddressModal = false;
                    this.isShowEmailDialog = false;
                    this.showOverTip = false;
                    this.showPrizePop = false;
                    setScroll.removeUnScroll();
                },

                // 显示我的奖品弹窗
                openMyPrize: function () {
                    if(!common.isLogin()){
                        this.needLogin();
                        return;
                    }
                    this.getPrizeHistory();
                    this.isShowMyPrize = true;
                },

                closeMyPrize: function () {
                    this.isShowMyPrize = false;
                },

                // 获取我的奖品
                getPrizeHistory: function () {
                    var _this = this;
                    var info = {
                        eventId: this.eventId,
                        session: common.isLogin().session,
                        OCSESSID: common.isLogin().OCSESSID
                    }
                    common.postJson(solution_host + '/api/lucky/getLuckLog', info, function (res) {
                        if (res.errCode === 0 && Array.isArray(res.data) && res.data.length > 0) {
                            _this.myPrizeList = res.data;
                        }
                    });
                },

                // 打开红包
                openPrize: function(item) {
                    switch (Number(item.type)) {
                        case 4:
                            this.hongbaoTitle = '微信红包';
                            this.hongbaoSub = '扫描公众号二维码，<br>或关注【戴尔企采网】公众号<br>查看微信红包了解更多活动';
                            break;
                        case 7:
                            this.hongbaoTitle = '腾讯视频VIP季度卡';
                            this.hongbaoSub = '前往“戴尔企采网”领取<br>腾讯视频VIP季度卡密';
                            break;
                        case 8:
                            this.hongbaoTitle = '滴滴100元充值卡';
                            this.hongbaoSub = '前往“戴尔企采网”领取<br>滴滴100元充值卡密';
                            break;
                        case 9:
                            this.hongbaoTitle = '爱奇艺视频VIP季度卡';
                            this.hongbaoSub = '前往“戴尔企采网”领取<br>爱奇艺视频VIP季度卡密';
                            break;
                        case 10:
                            this.hongbaoTitle = '芒果视频VIP季度卡';
                            this.hongbaoSub = '前往“戴尔企采网“领取<br>芒果视频VIP季度卡密';
                            break;
                        case 11:
                            this.hongbaoTitle = '优酷视频VIP季度卡';
                            this.hongbaoSub = '前往“戴尔企采网“领取<br>优酷视频VIP季度卡密';
                            break;
                    }
                    this.closeMyPrize();
                    this.getHongBaoQrImg(item.id);
                },

                // 显示红包二维码
                getHongBaoQrImg: function(logId) {
                    var _this = this;
                    var info = {
                        lid: logId,
                        session: common.isLogin().session,
                        OCSESSID: common.isLogin().OCSESSID
                    }
                    msg.loading().show();
                    common.getJson(solution_host + '/api/lucky/getLuckyQrCode', info, function (res) {
                        if (res.errCode === 0) {
                            _this.hongbaoQrImg = res.data.qrcode;
                            _this.isShowMyPrizeHongbao = true;
                        }
                        msg.loading().close();
                    })
                },

                // 跳转到我的优惠券
                jumpMyCoupon: function() {
                    common.gotoUrl('https://www.dellemc-solution.com/eshop/account/coupon')
                },
                // 获取新品惠购数据
                getNewProduct: function () {
                    var _this = this;
                    common.getJson((common.isM ? solution_m_host : solution_host) + '/api/campaign/promotion/new', {
                        newId: this.newId
                    }, function (res) {
                        if (res.errCode === 0) {
                            _this.newProductListYuan = res.data;
                            // 默认显示第一个子标签的数据
                            _this.handleNewProduct(_this.newProductTabList2.find(function(item) {
                                return item.isActived;
                            }).name);
                        }
                    });
                },
                // 处理数据显示
                handleNewProduct: function(tag) {
                    this.newProductList = this.newProductListYuan.filter(function(item) {
                        if (item.tags && item.tags.length) {
                            return item.tags.findIndex(function (tagText) {
                                return tagText === tag;
                            }) > -1;
                        }
                    });
                },
                // 切换新品惠购标签（一级）
                tab1Click: function (item) {
                    if (item.isActived) return;
                    this.newProductTabList2 = item.list.map(function (tab) {
                        tab.isActived = false;
                        return tab;
                    });
                    this.newProductTabList2[0].isActived = true;
                    this.newProductTabList.map(function (tab) {
                        tab.isActived = false;
                        return tab;
                    });
                    item.isActived = true;
                    this.handleNewProduct(this.newProductTabList2[0].name);
                },
                // 切换新品惠购标签（二级）
                tab2Click: function (item) {
                    if (item.isActived) return;
                    this.newProductTabList2.map(function (tab) {
                        tab.isActived = false;
                        return tab;
                    });
                    item.isActived = true;
                    this.handleNewProduct(item.name);
                }
            }
        });
    },


    init:function () {
        this.initVue();
        common.setupScrollBehavior(".bottom-actions");
    }
};
campaignPagee2026springModule.init();
